import React from "react";

function ForegroundImage({ image, isTermsAndCondition }) {
    return (
        <div className={`carousel-slide-foreground-img ${isTermsAndCondition ? "carousel-foreground-with-tc" : ""}`} >
            <div className="foreground-image"> 
                <img
                    src={image.src}
                    alt={image.alt}
                />
            </div>
        </div>
    );
}

export default ForegroundImage;
